import React from "react";
import { useNavigate } from "react-router-dom";
import { LangContext } from "../../context/LangContext";
import Bread from "../../common/Bread";

import savAc from "../../assets/service/saving-account.png";
import homeLoan from "../../assets/service/home-loan.png";
import intRate from "../../assets/service/int-rate.png";
import listTriangle from "../../assets/extras/listTraingle2.svg";

import "./product.scss";

const Product = () => {
  const navigate = useNavigate();
  const { state } = React.useContext(LangContext);
  const isNepali = state?.np;

  const breadcrumList = {
    image: "",
    title: isNepali ? "हाम्रा सेवाहरू" : "Products",
    l1: isNepali ? "गृहपृष्ठ" : "Home",
    l2: isNepali ? "हाम्रा सेवाको प्रकारहरू" : "Product Categories",
    l3: "",
  };

  const products = [
    {
      image: savAc,
      title: isNepali ? "बचत खाताहरू" : "Savings Account",
      features: [
        isNepali ? "सुविधाहरू र लाभहरू" : "Features & Benefits",
        isNepali ? "कसरी" : "Frequently Asked Questions",
        isNepali ? "योग्यता र कागजात" : "Eligibility & Documentation",
      ],
      route: "/product/saving-account/icfc-bumper-saving-account",
    },
    {
      image: homeLoan,
      title: isNepali ? "कर्जा" : "Loan Products",
      features: [
        isNepali ? "सुविधाहरू र लाभहरू" : "Features & Benefits",
        isNepali ? "कसरी" : "Frequently Asked Questions",
        isNepali ? "योग्यता र कागजात" : "Eligibility & Documentation",
      ],
      route: "/product/professional-loan/sme-loan",
    },
    {
      image: intRate,
      title: isNepali ? "फिक्स्ड डिपोजिट" : "Fixed Deposit",
      features: [
        isNepali ? "सुविधाहरू र लाभहरू" : "Features & Benefits",
        isNepali ? "कसरी" : "Frequently Asked Questions",
        isNepali ? "योग्यता र कागजात" : "Eligibility & Documentation",
      ],
      route: "/product/fixed-deposit/recurring-fixed-deposit",
    },
  ];

  return (
    <Bread data={breadcrumList}>
      <div className="product-main-container">
        {products.map((product, index) => (
          <div key={index} className="serviceItemContainer">
            <img src={product.image} alt={product.title} />
            <h2>{product.title}</h2>

            <ul
              className="serviceItemList"
              style={{ listStyleImage: `url(${listTriangle})` }}
            >
              {product.features.map((feature, i) => (
                <li key={i} className="serviceItemListItem">
                  {feature}
                </li>
              ))}
            </ul>

            <div className="ButtonContainer">
              <div
                className="know-more-button"
                onClick={() => navigate(product.route)}
              >
                {isNepali ? "थप जान्नुहोस्" : "Know More"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Bread>
  );
};

export default Product;
